import { useTenant } from "@/hooks/useTenant";
import { useAuth } from "@/hooks/useAuth";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Building2 } from "lucide-react";

export default function TenantSwitcher() {
  const { isSuperAdmin } = useAuth();
  const { tenantId, availableTenants, switchTenant } = useTenant();

  if (!isSuperAdmin || availableTenants.length === 0) return null;

  return (
    <div className="flex items-center gap-2">
      <Building2 className="h-4 w-4 text-muted-foreground" />
      <Select value={tenantId ?? undefined} onValueChange={switchTenant}>
        <SelectTrigger className="h-9 w-[220px]">
          <SelectValue placeholder="Selecionar loja" />
        </SelectTrigger>
        <SelectContent>
          {availableTenants.map((t) => (
            <SelectItem key={t.id} value={t.id}>
              {t.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
